var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoteAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.03,
    height: 46.512,
    viewBox: "0 0 54.03 46.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1132",
    "data-name": "\\uADF8\\uB8F9 1132",
    transform: "translate(2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_132",
    "data-name": "\\uD0C0\\uC6D0 132",
    transform: "translate(5.018)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.256,
    cy: 23.256,
    r: 23.256,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.256,
    cy: 23.256,
    r: 20.756,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1131",
    "data-name": "\\uADF8\\uB8F9 1131",
    transform: "translate(0 12.496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1346",
    "data-name": "\\uC0AC\\uAC01\\uD615 1346",
    width: 29.157,
    height: 22.215,
    transform: "translate(0.158 0)",
    fill: "#070e17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-down",
    "data-name": "Icon feather-arrow-down",
    transform: "translate(0 17.362) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_453",
    "data-name": "\\uD328\\uC2A4 453",
    d: "M0,0V26.994",
    transform: "translate(6.27 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_454",
    "data-name": "\\uD328\\uC2A4 454",
    d: "M12.54,0,6.27,6.27,0,0",
    transform: "translate(0 20.723)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteAccess);
export default __webpack_public_path__ + "static/media/remote_access.aa172065ab8a14029173dd188de8bef2.svg";
export { ForwardRef as ReactComponent };